(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zivo-gift-card-selector"]) return;
  try {
    
document.querySelectorAll('.zv-giftcards').forEach(function (root) {
  var strings = root.dataset;
  var cards = root.querySelectorAll('[data-zv-gc-card]');
  var panel = root.querySelector('[data-zv-gc-panel]');
  var selectedAmountEl = root.querySelector('[data-zv-gc-selected-amount]');
  var sendButtons = root.querySelectorAll('[data-zv-send]');
  var recipientFields = root.querySelector('[data-zv-recipient-fields]');
  var recipientFlag = root.querySelector('[data-zv-recipient-flag]');
  var recipientEmailInput = root.querySelector('[data-zv-recipient-email]');
  var qtyInput = root.querySelector('[data-zv-gc-qty-input]');
  var form = root.querySelector('[data-zv-gc-form]');
  var errorEl = root.querySelector('[data-zv-gc-error]');
  var submitBtn = root.querySelector('[data-zv-gc-submit]');
  var selectedVariantId = null;
  var sendMode = 'self';

  // If a card was already marked as selected server-side (the gift card
  // product the customer landed on), pick up that state on load.
  var preselected = root.querySelector('.zv-giftcards__card.is-selected');
  if (preselected) {
    selectedVariantId = preselected.getAttribute('data-variant-id');
    if (selectedAmountEl) selectedAmountEl.textContent = preselected.getAttribute('data-amount') || '';
  }

  cards.forEach(function (card) {
    card.addEventListener('click', function () {
      cards.forEach(function (c) {
        c.classList.remove('is-selected');
        c.setAttribute('aria-pressed', 'false');
      });
      card.classList.add('is-selected');
      card.setAttribute('aria-pressed', 'true');
      selectedVariantId = card.getAttribute('data-variant-id');
      if (selectedAmountEl) selectedAmountEl.textContent = card.getAttribute('data-amount') || '';
      if (panel) panel.hidden = false;
      if (errorEl) errorEl.hidden = true;
    });
  });

  sendButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      sendButtons.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      sendMode = btn.getAttribute('data-zv-send');
      var isRecipient = sendMode === 'recipient';
      if (recipientFields) recipientFields.hidden = !isRecipient;
      if (recipientFlag) recipientFlag.value = isRecipient ? 'on' : '';
      if (recipientEmailInput) recipientEmailInput.required = isRecipient;

      // Terug naar "For myself": maak de recipient-velden ook echt leeg,
      // niet alleen onzichtbaar/niet-verstuurd. Zo blijft er nergens een
      // spoor van eerder getypte naam/e-mail/bericht/datum hangen, ook
      // niet als iemand daarna weer op "For a recipient" klikt.
      if (!isRecipient && recipientFields) {
        recipientFields.querySelectorAll('input, textarea').forEach(function (field) {
          if (field === recipientFlag) return;
          field.value = '';
        });
      }
    });
  });

  root.querySelectorAll('[data-zv-gc-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!qtyInput) return;
      var val = parseInt(qtyInput.value, 10) || 1;
      if (btn.getAttribute('data-zv-gc-qty') === 'plus') val += 1;
      else val = Math.max(1, val - 1);
      qtyInput.value = val;
    });
  });

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (errorEl) errorEl.hidden = true;

      if (!selectedVariantId) {
        if (errorEl) { errorEl.textContent = strings.selectAmountError; errorEl.hidden = false; }
        return;
      }
      if (sendMode === 'recipient' && recipientEmailInput && !recipientEmailInput.value) {
        if (errorEl) { errorEl.textContent = strings.recipientEmailError; errorEl.hidden = false; }
        return;
      }

      // Alleen recipient-properties meesturen als "For a recipient" ook
      // echt actief staat. Zonder deze check zouden waardes die de klant
      // eerder in de recipient-velden typte (en daarna weer terug naar
      // "For myself" schakelde zonder de velden leeg te maken) alsnog als
      // line-item properties meegaan — form-velden blijven namelijk in de
      // FormData staan zolang ze niet leeg zijn, ook als hun container
      // "hidden" is.
      var recipientPropNames = ['Recipient name', 'Recipient email', 'Message', 'Send on', '__shopify_send_gift_card_to_recipient'];
      var formData = new FormData(form);
      var properties = {};
      formData.forEach(function (value, key) {
        var match = key.match(/^properties\[(.+)\]$/);
        if (!match || value === '') return;
        var propName = match[1];
        if (recipientPropNames.indexOf(propName) !== -1 && sendMode !== 'recipient') return;
        properties[propName] = value;
      });

      var payload = {
        items: [{
          id: parseInt(selectedVariantId, 10),
          quantity: parseInt(qtyInput ? qtyInput.value : 1, 10) || 1,
          properties: properties
        }]
      };

      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = strings.addingLabel; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (d) { throw new Error(d.description || d.message || 'Something went wrong.'); });
          }
          return res.json();
        })
        .then(function () {
          if (window.CustomCart && typeof window.CustomCart.openAfterAdd === 'function') {
            window.CustomCart.openAfterAdd();
          } else {
            window.location.href = '/cart';
          }
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = strings.addToCartLabel; }
        })
        .catch(function (err) {
          if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = strings.addToCartLabel; }
        });
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
